import { Button, ErrorLabel, Item, ItemActions, ItemContent, ItemHeader, ItemTitle } from '@ibsys/kit';
import { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { AttributeFormValues } from './validation';
import { SelectValueItem } from './SelectValueItem';

type Props = {
  className?: string;
  disabled?: boolean;
};

export const AttributeFormSelectValue: FC<Props> = ({ className, disabled }) => {
  const { t } = useTranslation(['attributes']);

  const {
    control,
    formState: { errors },
  } = useFormContext<AttributeFormValues>();

  const { fields, append, remove } = useFieldArray({ control: control, name: 'selectValues' });

  // Требование «нужно хотя бы одно значение» относится ко всему списку, а не к отдельному полю:
  // пока значений нет, ошибка приходит в message списка, а когда поля значений зарегистрированы — в root
  const listError = errors.selectValues?.root?.message ?? errors.selectValues?.message;

  const handleAddClick = () => {
    append({ name: '', description: '', code: '' });
  };

  return (
    <Item className={cn('gap-3 w-full max-w-155', className)} variant={'muted'}>
      <ItemHeader>
        <ItemTitle>{t('attributes:listValues')}</ItemTitle>
        <ItemActions>
          <Button className={''} size={'sm'} variant="ghost" onClick={handleAddClick}>
            {t('attributes:listAddValue')}
          </Button>
        </ItemActions>
      </ItemHeader>
      <ItemContent className={'w-full'}>
        <div className={'flex flex-col gap-2'}>
          {fields.map((field, idx) => (
            <SelectValueItem key={field.id} index={idx} disabled={disabled} onRemove={() => remove(idx)} />
          ))}
          {listError && <ErrorLabel>{listError}</ErrorLabel>}
        </div>
      </ItemContent>
    </Item>
  );
};
